import { NavLink } from "react-router-dom";

const InfoSection = () => {
    return (
        <section className="info-section container my-5">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h2 className="info-section-title">Star123 Satta Matka Charts</h2>
                        
                        <h2 className="info-section-subtitle">Accurate charts and historical records</h2>
                        <p className="info-section-text">
                            Welcome to Star123, your trusted platform for real-time Satta Matka charts and historical data. We provide structured Kalyan, Sridevi, Main Bazar and other market charts so you can track trends with clear, regularly updated records.
                        </p>

                        <h2 className="info-section-subtitle">Market chart collection</h2>
                        <p className="info-section-text">Browse popular market charts on Star123:</p>
                        <ul className="info-section-list" style={{ listStyleType: 'disc' }}>
                            <li><NavLink to="/charts/jodi/KALYAN" className="info-section-link">Kalyan jodi chart</NavLink></li>
                            <li><NavLink to="/charts/jodi/SRIDEVI" className="info-section-link">Sridevi jodi chart</NavLink></li>
                            <li><NavLink to="/charts/pana/SRIDEVI" className="info-section-link">Sridevi pana chart</NavLink></li>
                            <li><NavLink to="/charts/jodi/TIME BAZAR" className="info-section-link">Time Bazar jodi chart</NavLink></li>
                            <li><NavLink to="/charts/jodi/MILAN DAY" className="info-section-link">Milan Day chart</NavLink></li>
                            <li><NavLink to="/charts/jodi/MILAN NIGHT" className="info-section-link">Milan Night chart</NavLink></li>
                            <li><NavLink to="/charts/jodi/MADHUR DAY" className="info-section-link">Madhur Day chart</NavLink></li>
                            <li><NavLink to="/charts/jodi/RAJDHANI NIGHT" className="info-section-link">Rajdhani Night chart</NavLink></li>
                            <li><NavLink to="/charts/jodi/MAIN BAZAR" className="info-section-link">Main Bazar chart</NavLink></li>
                            <li><NavLink to="/charts" className="info-section-link">All Satta Matka charts</NavLink></li>
                        </ul>
                        <p className="info-section-text">
                            Each chart is updated regularly so you can review accurate historical data for analysis.
                        </p>

                        <h2 className="info-section-subtitle">Kalyan panel chart</h2>
                        <p className="info-section-text">
                            The <NavLink to="/charts/pana/KALYAN" className="info-section-link">Kalyan panel chart</NavLink> on Star123 shows number sequences and historical records. Use past outcomes to understand how the market has moved over time.
                        </p>

                        <h2 className="info-section-subtitle">Sridevi chart</h2>
                        <p className="info-section-text">
                            The <NavLink to="/charts/jodi/SRIDEVI" className="info-section-link">Sridevi chart</NavLink> helps you follow trends and past number sequences, with frequent updates for clearer history.
                        </p>

                        <h2 className="info-section-subtitle">Main Bazar chart</h2>
                        <p className="info-section-text">
                            Stay updated with the <NavLink to="/charts/jodi/MAIN BAZAR" className="info-section-link">Main Bazar chart</NavLink>, which offers a detailed view of historical results and number movements.
                        </p>

                        <h2 className="info-section-subtitle">Rajdhani Night & Milan Night charts</h2>
                        <p className="info-section-text">
                            For evening markets, the <NavLink to="/charts/jodi/RAJDHANI NIGHT" className="info-section-link">Rajdhani Night chart</NavLink> and <NavLink to="/charts/jodi/MILAN NIGHT" className="info-section-link">Milan Night chart</NavLink> provide structured past results and timely updates.
                        </p>

                        <h2 className="info-section-subtitle">Kalyan jodi chart</h2>
                        <p className="info-section-text">
                            The <NavLink to="/charts/jodi/KALYAN" className="info-section-link">Kalyan jodi chart</NavLink> focuses on number pairs. Review historical pair sequences with frequent chart updates.
                        </p>

                        <h2 className="info-section-subtitle">Milan Day & Madhur Day panel charts</h2>
                        <p className="info-section-text">
                            The <NavLink to="/charts/pana/MILAN DAY" className="info-section-link">Milan Day panel chart</NavLink> and <NavLink to="/charts/pana/MADHUR DAY" className="info-section-link">Madhur Day panel chart</NavLink> provide structured daily data for day-market trend review.
                        </p>

                        <h2 className="info-section-subtitle">Kalyan Night panel chart</h2>
                        <p className="info-section-text">
                            The <NavLink to="/charts/pana/KALYAN NIGHT" className="info-section-link">Kalyan Night panel chart</NavLink> is built for night-draw tracking, with structured updates so you can follow number movements clearly.
                        </p>

                        <h2 className="info-section-subtitle">How to use Star123 charts</h2>
                        <p className="info-section-text">Follow these steps to get the most from the charts:</p>
                        <ol className="info-section-list">
                            <li>Open the charts section on Star123.</li>
                            <li>Choose the market chart you need.</li>
                            <li>Review past results and patterns.</li>
                            <li>Track how often specific numbers appear.</li>
                            <li>Use historical context to refine your own analysis.</li>
                        </ol>

                        <h2 className="info-section-subtitle">Why use Star123 for chart data?</h2>
                        <p className="info-section-text">
                            Star123 is built for people who want clear Satta Matka chart access in one place:
                        </p>
                        <ul className="info-section-list">
                            <li><strong>Accurate & verified data</strong> – Charts are updated regularly for precise, timely results.</li>
                            <li><strong>User-friendly interface</strong> – A clean layout makes charts easy to read on any device.</li>
                            <li><strong>Complete historical records</strong> – Access past results to review longer-term trends.</li>
                            <li><strong>Broad chart collection</strong> – Find Kalyan, night panels and more without jumping across sites.</li>
                            <li><strong>Transparency</strong> – Data is shown clearly so you can review results with confidence.</li>
                        </ul>
                        <p className="info-section-text">
                            Need another market? Open the full <NavLink to="/charts" className="info-section-link">charts index</NavLink> or jump to popular pages like <NavLink to="/charts/jodi/KALYAN" className="info-section-link">Kalyan</NavLink>, <NavLink to="/charts/jodi/SRIDEVI" className="info-section-link">Sridevi</NavLink>, <NavLink to="/charts/jodi/MILAN DAY" className="info-section-link">Milan Day</NavLink> and <NavLink to="/charts/jodi/MAIN BAZAR" className="info-section-link">Main Bazar</NavLink>.
                        </p>

                        <h2 className="info-section-subtitle">How to track trends</h2>
                        <p className="info-section-text">To review number movements more effectively:</p>
                        <ul className="info-section-list">
                            <li>Compare related charts to cross-check results.</li>
                            <li>Check daily updates so you do not miss new draws.</li>
                            <li>Look at daily, weekly and monthly windows for context.</li>
                            <li>Compare older history with recent results for consistency.</li>
                        </ul>

                        <h2 className="info-section-subtitle">User experience on Star123</h2>
                        <p className="info-section-text">
                            We focus on a smooth experience when you open charts:
                        </p>
                        <ul className="info-section-list">
                            <li><strong>Clean layout</strong> – Simple navigation and readable tables.</li>
                            <li><strong>Fast updates</strong> – Timely chart refreshes.</li>
                            <li><strong>Multi-device access</strong> – Desktop, tablet and mobile.</li>
                            <li><strong>Reliable tracking</strong> – Clear historical records for analysis.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default InfoSection;
